import React from 'react'
import { FieldError } from 'react-hook-form'

export const ValidationError = ({ error }: { error?: FieldError }) => {
  if (!error) return null
  return (
    <p className="absolute -bottom-[1.3rem] left-0 text-left text-sm text-[#FF0000]">
      {error.message}
    </p>
  )
}
